"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _sceneBuilder = require("./sceneBuilder");
Object.keys(_sceneBuilder).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _sceneBuilder[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _sceneBuilder[key];
    }
  });
});